import { create } from 'zustand';
import { getListsByOwner } from '../util/util';
import { getSeenShowIdsForUser, getWantToSeeIdsByUser } from '../util/db';

const useUserShowsStore = create((set, get) => ({
  userId: null,
  userLists: [],
  seenShows: new Set(),
  wantToSeeShows: new Set(),
  savedListShows: new Set(),

  setSeenShows: seenShows => set({ seenShows }),
  setWantToSeeShows: wantToSeeShows =>
    set(state => ({
      wantToSeeShows,
      savedListShows: combineSaved(state.userLists, wantToSeeShows),
    })),

  reset: () =>
    set({
      userId: null,
      userLists: [],
      seenShows: new Set(),
      wantToSeeShows: new Set(),
      savedListShows: new Set(),
    }),

  fetchUserShows: async userId => {
    if (!userId) {
      get().reset();
      return;
    }
    try {
      const [userLists, seenShows, wantToSeeShows] = await Promise.all([
        getListsByOwner(userId),
        getSeenShowIdsForUser(userId),
        getWantToSeeIdsByUser(userId),
      ]);
      set({
        userId,
        userLists,
        seenShows,
        wantToSeeShows,
        savedListShows: combineSaved(userLists, wantToSeeShows),
      });
    } catch (error) {
      console.error('Failed to load user shows', error);
    }
  },
}));

function combineSaved(userLists, wantToSeeShows) {
  const saved = new Set(wantToSeeShows);
  (userLists ?? []).forEach(list => (list.shows ?? []).forEach(id => saved.add(id)));
  return saved;
}

export default useUserShowsStore;
